import type { DeviceLifecycleStatus } from "./api/devices";
import { t } from "./i18n";

type BadgeTone = "neutral" | "info" | "success" | "warning" | "danger";

const TONE_BY_STATUS: Record<DeviceLifecycleStatus, BadgeTone> = {
  pending_inventory: "warning",
  awaiting_policy: "info",
  active: "success",
  disabled: "neutral",
  deprovisioned: "danger",
};

export const LIFECYCLE_STATUS_OPTIONS: readonly DeviceLifecycleStatus[] = [
  "awaiting_policy",
  "active",
  "disabled",
  "deprovisioned",
];

export function lifecycleTone(status: DeviceLifecycleStatus): BadgeTone {
  return TONE_BY_STATUS[status] ?? "neutral";
}

export function lifecycleStatusLabel(status: DeviceLifecycleStatus): string {
  return t(`devices.lifecycleStatus.${status}`);
}
